import React, { useState, useEffect, useCallback } from 'react';
// @ts-ignore
import { AlertTriangle, AlertCircle, Info, RefreshCw } from 'lucide-react';
import { operationalDashboardService } from '../../services/operationalDashboard';

const SEVERITY_CONFIG: Record<string, { icon: any; color: string; bg: string; border: string }> = {
  alta: { icon: AlertTriangle, color: '#f87171', bg: 'rgba(239,68,68,0.08)', border: 'rgba(239,68,68,0.25)' },
  media: { icon: AlertCircle, color: '#facc15', bg: 'rgba(234,179,8,0.08)', border: 'rgba(234,179,8,0.25)' },
  baixa: { icon: Info, color: '#60a5fa', bg: 'rgba(59,130,246,0.08)', border: 'rgba(59,130,246,0.25)' }
};

const OperationalDashboardAlerts: React.FC = () => {
  const [alerts, setAlerts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchData = useCallback(async () => {
    try {
      setError('');
      const res = await operationalDashboardService.getAlerts();
      setAlerts(res.data || []);
    } catch (err: any) {
      setError('Erro ao carregar alertas. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, [fetchData]);

  if (loading) {
    return <div className="op-dashboard-loading"><div className="op-dashboard-spinner" />Carregando alertas...</div>;
  }

  if (error) {
    return <div className="op-dashboard-error">{error}</div>;
  }

  const alertasAlta = alerts.filter(a => a.severidade === 'alta');
  const alertasMedia = alerts.filter(a => a.severidade === 'media');

  return (
    <>
      <div className="op-dashboard-realtime-header">
        <h2 className="op-dashboard-section-title">
          <AlertTriangle size={18} /> Alertas Operacionais do Dia
        </h2>
        <button className="op-dashboard-filter-btn" onClick={fetchData} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <RefreshCw size={14} /> Atualizar
        </button>
      </div>

      {alerts.length === 0 ? (
        <div className="op-dashboard-empty" style={{ padding: 60, textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>&#10003;</div>
          <h3 style={{ color: '#4ade80', marginBottom: 8 }}>Nenhum alerta operacional</h3>
          <p style={{ color: '#94a3b8' }}>Tudo funcionando normalmente na operação.</p>
        </div>
      ) : (
        <>
          {alertasAlta.length > 0 && (
            <>
              <h3 className="op-dashboard-alert-section-title" style={{ color: '#f87171' }}>
                Severidade Alta ({alertasAlta.length})
              </h3>
              <div className="op-dashboard-alerts-list">
                {alertasAlta.map((a, i) => {
                  const cfg = SEVERITY_CONFIG[a.severidade] || SEVERITY_CONFIG.media;
                  const Icon = cfg.icon;
                  return (
                    <div key={i} className="op-dashboard-alert-item" style={{ background: cfg.bg, borderColor: cfg.border }}>
                      <div className="op-dashboard-alert-icon" style={{ color: cfg.color }}>
                        <Icon size={20} />
                      </div>
                      <div className="op-dashboard-alert-content">
                        <div className="op-dashboard-alert-title">{a.titulo}</div>
                        <div className="op-dashboard-alert-desc">{a.descricao}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {alertasMedia.length > 0 && (
            <>
              <h3 className="op-dashboard-alert-section-title" style={{ color: '#facc15' }}>
                Severidade Média ({alertasMedia.length})
              </h3>
              <div className="op-dashboard-alerts-list">
                {alertasMedia.map((a, i) => {
                  const cfg = SEVERITY_CONFIG[a.severidade] || SEVERITY_CONFIG.media;
                  const Icon = cfg.icon;
                  return (
                    <div key={i} className="op-dashboard-alert-item" style={{ background: cfg.bg, borderColor: cfg.border }}>
                      <div className="op-dashboard-alert-icon" style={{ color: cfg.color }}>
                        <Icon size={20} />
                      </div>
                      <div className="op-dashboard-alert-content">
                        <div className="op-dashboard-alert-title">{a.titulo}</div>
                        <div className="op-dashboard-alert-desc">{a.descricao}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default OperationalDashboardAlerts;
